/**
 * The Mapbox token is a public (`pk.`) token and is visible in the bundle by
 * design — that is how GL JS works. Protect it with URL restrictions in the
 * Mapbox dashboard (account settings → tokens → URL restrictions), not by trying
 * to hide it.
 */
export const MAPBOX_TOKEN = import.meta.env.VITE_MAPBOX_TOKEN ?? '';

export const MAP_STYLE = import.meta.env.VITE_MAP_STYLE ?? 'mapbox://styles/mapbox/outdoors-v12';

/**
 * Where a fresh planner opens: Norwich, which is where the routes are.
 *
 * GeoJSON order — longitude first — which is why this reads back to front
 * next to a latitude/longitude typed off a map.
 */
export const DEFAULT_CENTER: [number, number] = [1.131107, 52.64056];
export const DEFAULT_ZOOM = 9;

export const hasMapboxToken = MAPBOX_TOKEN.length > 0;
